import { useBackendData } from 'services/useBackendData';

import { campaignService } from './campaignService';

export const useCampaignData = (campaignId?: number) =>
  useBackendData(campaignService.fetchCampaignDetails, campaignId);
